import * as graphql from "../../../resolvers-types";
// import { generateUID } from "../../library/utils";  // CRITICAL: DO NOT USE THIS FUNCTION IN THE LIBRARY, USE THE ONE BELOW

// import { randomFillSync } from "crypto";

export function generateUID() {
  return generateRandomString(10);
}

// function generateRandomString(length) {
//   const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
//   // const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
//   let result = "";
//   const array: Uint8Array = new Uint8Array(length);
//   randomFillSync(array);

//   for (let i = 0; i < length; i++) {
//     result += chars[array[i] % chars.length];
//   }

//   return result;
// }

export const generateRandomString = (length: number): string => {
  const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  const array: Uint8Array = new Uint8Array(length);

  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    // Browser
    window.crypto.getRandomValues(array);
  } else {
    // Node.js (no `window`)
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const nodeCrypto = require("crypto");
    nodeCrypto.randomFillSync(array);
  }

  for (let i = 0; i < length; i++) {
    result += chars[array[i] % chars.length];
  }

  return result;
};

export const componentLibrary: graphql.ComponentLibrary = {
  __typename: "ComponentLibrary",
  Id: generateUID(),
  Name: "Components",
  Bindings: {
    Components:
      "State.Components?State.Components.map(function(c) \
      { ({__typename: 'LibraryItem', Id: c.Id,Name: c.Name, \
        Description: c.Description, \
        Category: c.Category, \
        Template: \
        { \
          __typename: 'Reference', \
          Id: uid(), \
          ReferenceType: 'Component', \
          ReferenceId: c.Id, \
          ReferenceSource: c.Source \
        } \
      }) }):[]",
  },

  Components: [],
};

export const controlLibrary: graphql.ComponentLibrary = {
  __typename: "ComponentLibrary",
  Id: generateUID(),
  Name: "Items",
  Components: [
    // {
    //   __typename: "LibraryItem",
    //   Id: generateUID(),
    //   Name: "Free Form Container",
    //   Icon: { IconName: "CropFreeOutlined" },
    //   Type: "Items",
    //   Description: "A description for SimpleContainer",
    //   Category: "Containers",
    //   SubCategory: "",
    //   InitialWidth: 5,
    //   InitialHeight: 25,
    //   Template: {
    //     __typename: "SimpleContainer",
    //     Id: generateUID(),
    //     Items: [],
    //     Layout: {
    //       __typename: "FreeFormLayout",
    //     },
    //   },
    // },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Vertical Container",
      Icon: { IconName: "AspectRatioOutlined" },
      Type: "Items",
      Description: "A description for FlexContainer",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "SimpleContainer",
        Id: generateUID(),
        Items: [],
        IgnoreLayout: true,
        Style: {
          display: "flex",
          flexDirection: "column",
          minWidth: "20px",
          minHeight: "20px",
        },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Horizontal Container",
      Icon: { IconName: "AspectRatioOutlined" },
      Type: "Items",
      Description: "A description for FlexContainer",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "SimpleContainer",
        Id: generateUID(),
        Items: [],
        IgnoreLayout: true,
        Style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          minWidth: "20px",
          minHeight: "20px",
        },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Dialog",
      Icon: { IconName: "LaunchOutlined" },
      Type: "Items",
      Description: "A description for Dialog",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "Dialog",
        Id: generateUID(),
        ContentContainer: {
          __typename: "SimpleContainer",
          Id: generateUID(),
          Items: [],
          IgnoreLayout: true,
          Style: {
            display: "flex",
            flexDirection: "column",
            minWidth: "20px",
            minHeight: "20px",
          },
        },
        Style: {},
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Button",
      Icon: { IconName: "SmartButtonOutlined" },
      Type: "Items",
      Description: "A description for Button",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Button",
        Label: "Button",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Column",
      Icon: { IconName: "ViewColumnOutlined" },
      Type: "Items",
      Description: "A description for List Column",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "ListColumn",
        HeaderName: "New Column",
        Name: "NewColumn",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Label",
      Icon: { IconName: "AbcOutlined" },
      Type: "Items",
      Description: "A description for Label",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Label",
        Value: "Label",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Link",
      Icon: { IconName: "Link" },
      Type: "Items",
      Description: "A description for Link",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Link",
      },
    }, //
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Html",
      Icon: { IconName: "Language" },
      Type: "Items",
      Description: "A description for HTML",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        Icon: { IconName: "Language" },
        __typename: "Html",
        Value: "</b>Html<b>",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Audio Player",
      Icon: { IconName: "PlayArrowOutlined" },
      Type: "Items",
      Description: "A description for Audio Players",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        Icon: { IconName: "Language" },
        __typename: "AudioPlayer",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Markdown",
      Icon: { IconName: "DescriptionOutlined" },
      Type: "Items",
      Description: "A description for Markdown",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        Icon: { IconName: "Language" },
        __typename: "Markdown",
        Value: "## Markdown",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Multi-Select",
      Icon: { IconName: "ArrowDropDownCircleOutlined" },
      Type: "Items",
      Description: "A description for MultiSelect",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "MultiSelect",
        Label: "MultiSelect",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Checkbox",
      Icon: { IconName: "CheckBoxOutlined" },
      Type: "Items",
      Description: "A description for Checkbox",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Checkbox",
        Label: "Checkbox",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Slider",
      Icon: { IconName: "LinearScaleOutlined" },
      Type: "Items",
      Description: "A description for Slider",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Slider",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Switch",
      Icon: { IconName: "ToggleOffOutlined" },
      Type: "Items",
      Description: "A description for Switch",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Switch",
        Label: "Label for Switch",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Input Field",
      Icon: { IconName: "Crop169Outlined" },
      Type: "Items",
      Description: "A description for InputField",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "InputField",
        Label: "Label for InputField",
        Style: { margin: "0px", width: "100%" },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Rich Text Editor",
      Icon: { IconName: "TextSnippetOutlined" },
      Type: "Items",
      Description: "A description for RichTextEditor",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "RichTextEditor",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Accordion",
      Icon: { IconName: "AspectRatioOutlined" },
      Type: "Items",
      Description: "A description for FlexContainer",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "AccordionLayout",
        Id: generateUID(),
        Groups: [
          {
            __typename: "AccordionGroup",
            Id: generateUID(),
            Label: `Accordion Group`,
            Header: {
              __typename: "SimpleContainer",
              Id: generateUID(),
              Items: [
                {
                  __typename: "Label",
                  Id: generateUID(),
                  Value: "Accordion Header",
                },
              ],
              IgnoreLayout: true,
              Style: {
                display: "flex",
                flexDirection: "column",
                minWidth: "20px",
                minHeight: "20px",
              },
            },
            Items: [
              {
                __typename: "SimpleContainer",
                Id: generateUID(),
                Items: [
                  {
                    __typename: "Label",
                    Id: generateUID(),
                  },
                ],
                IgnoreLayout: true,
                Style: {
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "20px",
                  minHeight: "20px",
                },
              },
            ],
          },
        ],
        Style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: "20px",
          minHeight: "20px",
        },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Date Picker",
      Icon: { IconName: "CalendarToday" },
      Type: "Items",
      Description: "A description for Date Picker",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "DatePicker",
        Label: "Date",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Time Picker",
      Icon: { IconName: "AccessTime" },
      Type: "Items",
      Description: "A description for Time Picker",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "TimePicker",
        Label: "Time",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "TimeZone Picker",
      Icon: { IconName: "ArrowDropDownCircleOutlined" },
      Type: "Items",
      Description: "A description for Date Picker",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "TimeZonePicker",
        Label: "Time Zone",
      },
    },

    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Radio Group",
      Icon: { IconName: "RadioButtonChecked" },
      Type: "Items",
      Description: "A description for RadioGroup",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "RadioGroup",
        MultiSelectPossibleValues: ["Option1", "Option2", "Option3"],
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Avatar",
      Icon: { IconName: "AccountCircleOutlined" },
      Type: "Items",
      Description: "A description for Image",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Avatar",
      } as graphql.Avatar,
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Image",
      Icon: { IconName: "InsertPhotoOutlined" },
      Type: "Items",
      Description: "A description for Image",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Image",
        // Width: "100%",
        // Height: "auto",
        Value: "communify-finance-logo.webp",
      } as graphql.Image,
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "File Upload",
      Icon: { IconName: "UploadFileOutlined" },
      Type: "Items",
      Description: "A description for FileUpload",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "FileUpload",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Document Viewer",
      Icon: { IconName: "FindInPageOutlined" },
      Type: "Items",
      Description: "A description for DocumentViewer",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "DocumentViewer",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Tab Container",
      Icon: { IconName: "TabOutlined" },
      Type: "Items",
      Description: "A description for TabContainer",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "TabContainer",
        Id: generateUID(),
        BoxStyle: { width: "100%" },
        Items: [
          {
            __typename: "TabItem",
            Id: generateUID(),
            Title: "Tab 1",
            Items: [
              {
                __typename: "SimpleContainer",
                Id: generateUID(),
                Items: [],
                IgnoreLayout: true,
                Style: {
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "20px",
                  minHeight: "20px",
                },
              },
            ],
          },
          {
            __typename: "TabItem",
            Id: generateUID(),
            Title: "Tab 2",
            Items: [
              {
                __typename: "SimpleContainer",
                Id: generateUID(),
                Items: [],
                IgnoreLayout: true,
                Style: {
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "20px",
                  minHeight: "20px",
                },
              },
            ],
          },
        ],
        Classes: ["tab-large"],
      },
    },

    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Repeater",
      Icon: { IconName: "AutoAwesomeMotionOutlined" },
      Type: "Items",
      Description: "A description for Repeater",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "Repeater",
        Id: generateUID(),
        Variant: "Flex",
        Items: [
          {
            __typename: "SimpleContainer",
            Id: generateUID(),
            Items: [],
            IgnoreLayout: true,
            Style: {
              display: "flex",
              flexDirection: "column",
              minWidth: "20px",
              minHeight: "20px",
            },
          },
        ],
        Layout: {
          Id: generateUID(),
          __typename: "FlexLayout",
          Direction: "column",
        },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Data Grid",
      Icon: { IconName: "TableChartOutlined" },
      Type: "Items",
      Description: "Grid with groupping filtering",
      Category: "Containers",
      SubCategory: "Data",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "List",
        Id: generateUID(),
        ShowExport: true,
        ShowClearAllFilters: true,
        ShowFloatingFilter: true,
        ShowQuickFilter: true,
        Style: { width: "100%" },
        GridLayout: "normal",
        ListColumns: [
          {
            __typename: "ListColumn",
            Id: generateUID(),
            HeaderName: "Id",
            Name: "Id",
            IsPrimaryKey: true,
          },
          {
            __typename: "ListColumn",
            Id: generateUID(),
            HeaderName: "Name",
            Name: "Name",
          },
          {
            __typename: "ListColumn",
            Id: generateUID(),
            HeaderName: "Ticker",
            Name: "Ticker",
          },
          {
            __typename: "ListColumn",
            Id: generateUID(),
            HeaderName: "Quote",
            Name: "Quote",
          },
        ],
        Rows: [
          {
            Id: 1,
            Name: "NVIDIA",
            Ticker: "NVDA",
            Quote: 67.87,
            FileExtension: "pdf",
          },
          {
            Id: 2,
            Name: "Microsoft",
            Ticker: "MSFT",
            Quote: 152.17,
            FileExtension: "png",
          },
          {
            Id: 3,
            Name: "Apple",
            Ticker: "AAPL",
            Quote: 200.15,
            FileExtension: "docx",
          },
          {
            Id: 4,
            Name: "Meta",
            Ticker: "META",
            Quote: 537.95,
            FileExtension: "xlsx",
          },
        ],
        Items: [
          {
            __typename: "SimpleContainer",
            Id: "mi65126nd0",
            IgnoreLayout: true,
            Style: {
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              minHeight: "20px",
              flex: 1,
              justifyContent: "space-between",
            },
            Items: [
              {
                __typename: "ListExportButton",
                EnableCSV: true,
                EnableExcel: true,
                Id: generateUID(),
              },
              {
                __typename: "ListQuickFilter",
                Actions: [],
                Adornment: {
                  Position: "Start",
                  Icon: {
                    IconName: "Search",
                  },
                },
                Id: generateUID(),
              },
            ],
          },
        ],
      },
    },

    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Menu",
      Icon: { IconName: "Menu" },
      Type: "Items",
      Description: "Visible Menu",
      Category: "Containers",
      SubCategory: "Data",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "VisibleMenu",
        Id: generateUID(),
      },
    },

    // {
    //   __typename: "LibraryItem",
    //   Id: generateUID(),
    //   Name: "Data Grid",
    //   Icon: { IconName: "TableChartOutlined" },
    //   Type: "Items",
    //   Description: "A description for Data Grid",
    //   Category: "Container",
    //   SubCategory: "",
    //   InitialWidth: 5,
    //   InitialHeight: 25,
    //   Template: {
    //     __typename: "List",
    //     Id: generateUID(),
    //     ShowExport: true,
    //     ShowFilter: true,
    //     Style: { width: "100%" },
    //     ListColumns: [
    //       {
    //         __typename: "ListColumn",
    //         Id: generateUID(),
    //         HeaderName: "Id",
    //         Name: "Id",
    //         IsPrimaryKey: true,
    //       },
    //       {
    //         __typename: "ListColumn",
    //         Id: generateUID(),
    //         HeaderName: "Column 1",
    //         Name: "Column1",
    //       },
    //       {
    //         __typename: "ListColumn",
    //         Id: generateUID(),
    //         HeaderName: "Column 2",
    //         Name: "Column2",
    //       },
    //     ],
    //     Rows: [],
    //   },
    // },

    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Dynamic App",
      SerialNumber: "..",
      Icon: { IconName: "SettingsOutlined" },
      Type: "Items",
      Description: "Dynamic App",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "dynamic-market-app",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Chart Basic - Stock",
      SerialNumber: "FMR.7319.M.01.STKBCH",
      Icon: { IconName: "ShowChart" },
      Type: "Items",
      Description: "Chart Basic - Stock",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "basic-chart",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "IFrame",
      Icon: { IconName: "CropOriginal" },
      Type: "Items",
      Description: "IFrame",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "IFrame",
        Id: generateUID(),
        Width: "100%",
        Height: "500px",
        Style: {
          border: "none",
        },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Sectors & Industries",
      SerialNumber: "FMR.7002.M.01.SCT&IND",
      Icon: { IconName: "Factory" },
      Type: "Items",
      Description: "Sectors & Industries",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "sector-and-industries",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Sectors & Industries - Comparison",
      SerialNumber: "FA.7002.C.01.MRK",
      Icon: { IconName: "Factory" },
      Type: "Items",
      Description: "Sectors & Industries - Comparison",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "sectors-industries-comparison",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Indices - List",
      Icon: { IconName: "Leaderboard" },
      Type: "Items",
      Description: "Indices - List",
      SerialNumber: "FMR.8104.M.01.INDXLST",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "indices",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Company Profile",
      SerialNumber: "FMR.7317.M.01.COPFL",
      Icon: { IconName: "AccountCircle" },
      Type: "Items",
      Description: "Company Profile",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-profile",
        Exchange: "NASQ",
        Symbol: "AAPL",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Dividends",
      SerialNumber: "FMM.7311.M.01.SSDIV",
      Icon: { IconName: "AttachMoney" },
      Type: "Items",
      Description: "Fin Basic Chart",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-dividends",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Performance",
      SerialNumber: "FMM.7307.M.01.SSPRF",
      Icon: { IconName: "QueryStats" },
      Type: "Items",
      Description: "Stock Story - Performance",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-performance",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Earnings",
      SerialNumber: "FMM.7310.M.01.SSEARN",
      Icon: { IconName: "StackedLineChart" },
      Type: "Items",
      Description: "Stock Story - Earnings",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-earnings",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Profitablility",
      SerialNumber: "FMM.7304.M.01.SSPRFIT",
      Icon: { IconName: "Paid" },
      Type: "Items",
      Description: "Fin Basic Chart",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-profitability",
      },
    },
    // {
    //   __typename: "LibraryItem",
    //   Id: generateUID(),
    //   Name: "Fin Stock Story Outlook",
    //   Icon: { IconName: "BarChart" },
    //   Type: "Items",
    //   Description: "Fin Basic Chart",
    //   Category: "Market Apps",
    //   SubCategory: "",
    //   InitialWidth: 5,
    //   InitialHeight: 25,
    //   Template: {
    //     __typename: "FinApp",
    //     Id: generateUID(),
    //     Type: "stock-story-outlook",
    //   },
    // },
    // {
    //   __typename: "LibraryItem",
    //   Id: generateUID(),
    //   Name: "Fin Stock Story Peers News",
    //   Icon: { IconName: "BarChart" },
    //   Type: "Items",
    //   Description: "Fin Basic Chart",
    //   Category: "Market Apps",
    //   SubCategory: "",
    //   InitialWidth: 5,
    //   InitialHeight: 25,
    //   Template: {
    //     __typename: "FinApp",
    //     Id: generateUID(),
    //     Type: "stock-story-peers-news",
    //   },
    // },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Growth",
      Icon: { IconName: "TrendingUp" },
      SerialNumber: "FMM.7308.M.01.SSGRW",
      Type: "Items",
      Description: "Stock Story - Growth",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-growth",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Fin Stock Story Overvalued",
      Icon: { IconName: "WaterfallChart" },
      Type: "Items",
      Description: "Fin Basic Chart",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-overvalued",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Debt",
      SerialNumber: "FMM.7315.M.01.SSDBT",
      Icon: { IconName: "AccountBalance" },
      Type: "Items",
      Description: "Stock Story - Debt",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-debt",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Fin Stock Story Forecast",
      Icon: { IconName: "SsidChart" },
      Type: "Items",
      Description: "Fin Basic Chart",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-forecast",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Portfolio Fit",
      SerialNumber: "FMM.7306.M.01.SSPRTFT",
      Icon: { IconName: "QueryStats" },
      Type: "Items",
      Description: "Stock Story - Portfolio Fit",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-portfolio-fit",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Dynamic Video",
      Icon: { IconName: "OndemandVideo" },
      SerialNumber: "FMR.7903.M.01.DYNVID",
      Type: "Items",
      Description: "Dynamic Video",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "dv-market-update",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Watchlist MIND Events",
      SerialNumber: "FMR.7905.M.01.WTLSTMND",
      Icon: { IconName: "TravelExplore" },
      Type: "Items",
      Description: "Watchlist MIND Events",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "mind-events",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Company Profile",
      SerialNumber: "FMR.7317.M.01.COPFL",
      Icon: { IconName: "Business" },
      Type: "Items",
      Description: "Company Profile",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "company-profile",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Competitors",
      SerialNumber: "FMR.7324.M.01.STKCOMP",
      Icon: { IconName: "Group" },
      Type: "Items",
      Description: "Competitors",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "competitors",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Estimates",
      SerialNumber: "FMR.7321.M.01.STKEST",
      Icon: { IconName: "TrendingUp" },
      Type: "Items",
      Description: "Estimates",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "estimates",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Market Movers",
      SerialNumber: "FMR.7001.M.01.MKTMV",
      Icon: { IconName: "Timeline" },
      Type: "Items",
      Description: "Market Movers",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "market-movers",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Market Status",
      SerialNumber: "FMR.7014.M.01.MRKTSTATUS",
      Icon: { IconName: "TrendingUp" },
      Type: "Items",
      Description: "Market Status",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "market-status",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Sustainability",
      SerialNumber: "FMR.7329.M.01.STKSUS",
      Icon: { IconName: "AllInclusive" },
      Type: "Items",
      Description: "Sustainability",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "esg",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Advanced Charting - Stocks",
      SerialNumber: "FMR.7328.M.01.STKACH",
      Icon: { IconName: "StackedBarChart" },
      Type: "Items",
      Description: "Advanced Charting - Stocks",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "advanced-chart", // or fwc-advanced-chart-tools
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Events",
      SerialNumber: "FMR.7326.M.01.STKEVTS",
      Icon: { IconName: "Event" },
      Type: "Items",
      Description: "Events",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "events",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Financial Health/Statements",
      SerialNumber: "FMR.7320.M.01.STKHLTH",
      Icon: { IconName: "HealthAndSafety" },
      Type: "Items",
      Description: "Financial Health/Statements",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "financial-health",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Fin Smart Text",
      Icon: { IconName: "HistoryEdu" },
      Type: "Items",
      Description: "Fin Smart Text",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "smarttext",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Fin News",
      Icon: { IconName: "Article" },
      Type: "Items",
      Description: "Fin News",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "news",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Ownership",
      SerialNumber: "FMR.7322.M.01.STKOWN",
      Icon: { IconName: "AssignmentInd" },
      Type: "Items",
      Description: "Ownership",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "ownership",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Fin Quote",
      Icon: { IconName: "FormatQuote" },
      Type: "Items",
      Description: "Fin Quote",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "quote",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Ratios",
      SerialNumber: "FMR.7323.M.01.STKRAT",
      Icon: { IconName: "BarChart" },
      Type: "Items",
      Description: "Ratios",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "ratios",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Security Search",
      SerialNumber: "FMR.7906.M.01.SECSRCH",
      Icon: { IconName: "Search" },
      Type: "Items",
      Description: "Security Search",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "search",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Key Executives/Management",
      SerialNumber: "FMR.7327.M.01.STKEXEC",
      Icon: { IconName: "SupervisorAccount" },
      Type: "Items",
      Description: "Key Executives/Management",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "top-executives",
      },
    },

    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Chart",
      Icon: { IconName: "Addchart" },
      Type: "Items",
      Description: "A description for Chart",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Chart",
        ChartLibrary: "AGChart",
        ChartMetadata: {},
      },
    },

    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Circular Progress",
      Icon: { IconName: "RestartAltOutlined" },
      Type: "Items",
      Description: "A description for CircularProgress",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "CircularProgress",
        Variant: graphql.CircularProgressVariant.Indeterminate,
        Value: 27,
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Linear Progress",
      Icon: { IconName: "HorizontalRuleOutlined" },
      Type: "Items",
      Description: "A description for LinearProgress",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "LinearProgress",
        Variant: graphql.LinearProgressVariant.Indeterminate,
        Value: 27,
        ValueBuffer: 50,
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Json View",
      Icon: { IconName: "DataObject" },
      Type: "Items",
      Description: "A description for JsonView",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "JsonView",
        Source: {
          key: "value",
        },
      },
    },

    // {
    //   __typename: "LibraryItem",
    //   Id: generateUID(),
    //   Name: "List",
    //   Icon: { IconName: "TableRows" },
    //   Type: "Items",
    //   Description: "A description for List",
    //   Category: "Some Category",
    //   SubCategory: "",
    //   InitialWidth: 5,
    //   InitialHeight: 25,
    //   Template: {
    //     Id: generateUID(),
    //     __typename: "List",
    //   },
    // },
  ],

  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "AI Dialog",
  //   Icon: { IconName: "Tungsten" },
  //   Type: "Items",
  //   Description: "A description for AIDialog",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "AIDialogContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "AIDialog",
  //             Label: "Label for AIDialog",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Visible Menu",
  //   Icon: { IconName: "Menu" },
  //   Type: "Items",
  //   Description: "A description for VisibleMenu",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "VisibleMenuContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "VisibleMenu",
  //             Label: "Label for VisibleMenu",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },

  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Radio Group",
  //   Icon: { IconName: "RadioButtonChecked" },
  //   Type: "Items",
  //   Description: "A description for RadioGroup",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "RadioGroupContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "RadioGroup",
  //             Label: "Label for RadioGroup",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },

  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Code Editor",
  //   Icon: { IconName: "Code" },
  //   Type: "Items",
  //   Description: "A description for CodeEditor",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "CodeEditorContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "CodeEditor",
  //             Label: "Label for CodeEditor",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Form",
  //   Icon: { IconName: "Ballot" },
  //   Type: "Items",
  //   Description: "A description for Form",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "FormContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "Form",
  //             Label: "Label for Form",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },

  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Tree List",
  //   Icon: { IconName: "AccountTree" },
  //   Type: "Items",
  //   Description: "A description for TreeList",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "TreeListContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "TreeList",
  //             Label: "Label for TreeList",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Feed",
  //   Icon: { IconName: "ViewStream" },
  //   Type: "Items",
  //   Description: "A description for Feed",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "FeedContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "Feed",
  //             Label: "Label for Feed",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Repeater",
  //   Icon: { IconName: "AutoAwesomeMotion" },
  //   Type: "Applications",
  //   Description: "A description for Repeater",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "RepeaterContainer",
  //     Items: [
  //       {
  //         Typename: "Repeater",
  //         UniqueName: generateUID(),
  //         Id: generateUID(),
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "IFrame",
  //   Icon: { IconName: "FilterFrames" },
  //   Type: "Items",
  //   Description: "A description for IFrame",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "IFrameContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "IFrame",
  //             Label: "Label for IFrame",
  //             Source: "",
  //           } as graphql.IFrame,
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Image",
  //   Icon: { IconName: "InsertPhoto" },
  //   Type: "Items",
  //   Description: "A description for Image",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "ImageContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "Image",
  //             Label: "Label for Image",
  //             Value: "",
  //           } as graphql.Image,
  //         ],
  //       },
  //     ],
  //   },
  // },

  Actions: [
    // {
    //   Trigger: "onComponentSelected",
    //   CommandSet: {
    //     FirstCommandId: "1",
    //     ExecuteCommandsInParallel: false,
    //     Commands: [
    //       {
    //         Id: "1",
    //         Instruction: {
    //           Name: "SendMessageToChild",
    //         },
    //         Parameters: [
    //           {
    //             Name: "IFrame",
    //             Value: "EditorIFrame",
    //           },
    //           {
    //             Name: "Type",
    //             Value: "addControl",
    //           },
    //           {
    //             Name: "Bindings",
    //             Value: {
    //               Control: "Event",
    //             },
    //           },
    //           {
    //             Name: "Actions",
    //             Value: [
    //               {
    //                 Trigger: "addControl",
    //                 CommandSet: {
    //                   FirstCommandId: "1",
    //                   ExecuteCommandsInParallel: false,
    //                   Commands: [
    //                     {
    //                       Id: "1",
    //                       Instruction: {
    //                         Name: "SetState",
    //                       },
    //                       Parameters: [
    //                         {
    //                           // TODO: fix these bindings, we don't need them to do this any more
    //                           Name: "Bindings",
    //                           Value: {
    //                             "State.Container.FormApplications":
    //                               "(State.Container.FormApplications || []).concat([Event.Control.ComponentContainer])",
    //                             "State.LatestControl": "State.Container.FormApplications.slice(-1)[0]",
    //                             "State.Page.Containers": "(State.Page.Containers || []).concat(State.LatestControl)",
    //                           },
    //                         },
    //                       ],
    //                     },
    //                   ],
    //                 },
    //               },
    //             ],
    //           },
    //         ],
    //       },
    //     ],
    //   },
    // },
  ],
};
